import axios from 'axios';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../redux/features/auth/authSliceNew';


export const fynitoApi = axios.create({
    baseURL: 'https://fynito.com/user',
});

// Track if response interceptor is already set up to prevent duplicates
let responseInterceptorId = null;

// Add a request interceptor to include the token in all requests
fynitoApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        // Only use token if it exists, don't use fallback token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Custom setup function
export const setupInterceptors = (logoutCallback) => {
    // Remove existing interceptor if it exists to prevent duplicates
    if (responseInterceptorId !== null) {
        fynitoApi.interceptors.response.eject(responseInterceptorId);
    }
    
    // Set up new response interceptor
    responseInterceptorId = fynitoApi.interceptors.response.use(
        response => response,
        error => {
            // Handle 401 Unauthorized errors
            if (error.response && error.response.status === 401) {
                // Only log warning if there was a token (expired/invalid)
                // If no token, this is expected for unauthenticated requests
                const hadToken = !!localStorage.getItem('token');
                if (hadToken) {
                    console.warn("Unauthorized - Token expired or invalid. Logging out...");
                }
                
                // Clear token from localStorage
                localStorage.removeItem('token');
                
                // Call logout callback to update Redux state (only if there was a token)
                if (hadToken && logoutCallback) {
                    try {
                        logoutCallback();
                    } catch (callbackError) {
                        console.error("Error in logout callback:", callbackError);
                    }
                }
                
                // Only redirect if user was logged in and not already on home page
                if (hadToken) {
                    setTimeout(() => {
                        if (window.location.pathname !== '/') {
                            window.location.href = '/';
                        }
                    }, 100);
                }
                
                // Mark the original error as handled (preserve all error properties)
                if (error.isAxiosError) {
                    error.isHandled = true;
                    error._isHandled401 = true;
                    // Ensure status is set
                    if (!error.status) {
                        error.status = 401;
                    }
                } else {
                    // If not an AxiosError, create one with handled flag
                    const handledError = new Error('Unauthorized');
                    handledError.isHandled = true;
                    handledError._isHandled401 = true;
                    handledError.status = 401;
                    handledError.response = error.response;
                    handledError.isAxiosError = true;
                    return Promise.reject(handledError);
                }
                
                // Return a rejected promise with handled flag
                // The global handler will prevent it from showing in React's error overlay
                return Promise.reject(error);
            }
            return Promise.reject(error);
        }
    );
};



